export class CfetRegExContant {
    public static pd_format = /[a-z0-9\W_]/i;
    public static firstNetId_format = '(?=.{8,}$)[A-Z0-9a-z._%+-]+@[A-Za-z0-9._-]+\\.[A-Za-z]{2,}';
    // eslint-disable-next-line max-len
    public static userId_format = `[a-zA-Z0-9!@#\$%\^\&*\)\(}{\\]\\[\?\/\|\\\\+<>=.,;:'"_-]+@[a-zA-Z0-9!@#\$%\^\&*\)\(}{\\]\\[\?\/\|\\\\+<>=.,;:'"_-]+\\.[a-zA-Z0-9!@#\$%\^\&*\)\(}{\\]\\[\?\/\|\\\\+<>=.,;:'"_-]{2,}`;
    public static agentSpaOrgId_format = /^[A-Za-z0-9]+$/;
    public static numRule = /\d/g;
    // pattern for special characters
    public static specialCharsRule = /[\W_]/g;
    // pattern for Alphabets
    public static smallLetterRule = /[a-z]/g;
    public static capitalLetterRule = /[A-Z]/g;
    public static repeating3 = /([a-z0-9\W_])\1\1/ig;
}
